import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  merchantKYC: {
    isAdharVerified: false,
  },
  merchantBasicDetails: {},
  merchantProfileDetails: {},
  bankDetails: {
    isBankVerified: false,
  },
  organisationDetails: {
    isOrganisationVerified: false,
  },
};

const merchantForm = createSlice({
  name: "merchantForm",
  initialState,
  reducers: {
    updateInitialState: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        if (key in state && typeof state[key as keyof typeof state] === "object") {
          state[key as keyof typeof state] = {
            ...state[key as keyof typeof state],
            ...action.payload[key],
          };
        }
      });
    },
    updateMerchantKYC: (state, action) => {
      // Merge the new details with the existing ones
      state.merchantKYC = {
        ...state.merchantKYC,
        ...action.payload,
      };
    },
    updateMerchantBasicDetails: (state, action) => {
      state.merchantBasicDetails = {
        ...state.merchantBasicDetails, 
        ...action.payload, 
      };
    },
    updateMerchantProfileDetails: (state, action) => {
      state.merchantProfileDetails = action.payload;
    },
    updateBankDetails: (state, action) => {
      state.bankDetails = action.payload;
    },
    updateOrganisationDetails: (state, action) => {
      state.organisationDetails = {
        ...state.organisationDetails,
        ...action.payload
      };
    },

    // Reset Actions
    resetMerchantKYC: (state) => {
      state.merchantKYC = {
        ...initialState.merchantKYC,
          isAdharVerified: false,
      };
    },
    resetMerchantBasicDetails: (state) => {
      state.merchantBasicDetails = initialState.merchantBasicDetails;
    },
    resetMerchantProfileDetails: (state) => {
      state.merchantProfileDetails = initialState.merchantProfileDetails;
    },
    resetBankDetails: (state) => {
      state.bankDetails = initialState.bankDetails;
    },
    resetOrganisationDetails: (state) => {
      state.organisationDetails = initialState.organisationDetails;
    },
    resetMerchantState: () => initialState,

  },
});

export const {
  updateMerchantKYC,
  updateMerchantBasicDetails,
  updateMerchantProfileDetails,
  updateBankDetails,
  updateOrganisationDetails,
  resetMerchantKYC,
  resetMerchantBasicDetails,
  resetMerchantProfileDetails,
  resetBankDetails,
  resetOrganisationDetails,
  resetMerchantState,
  updateInitialState
  
} = merchantForm.actions;

export default merchantForm.reducer;
